import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { Card, Flex, Image, Stack, Text } from '@mantine/core';

import { HeadquarterContext } from 'context/HeadquarterContext';

import { ThirdPartyMenus } from 'components/ThirdPartyMenus';

import HalftoneTakeout from 'assets/images/halftone-takeoutChinese.png';
import { Schedule } from 'containers/PosIntegrations/ToastPos/Schedule';

export const RedirectMiddleware: FunctionComponent = () => {
  const { location } = useContext(HeadquarterContext);

  if (!location) {
    return null;
  }

  return (
    <Stack gap={0}>
      <Card p="xl">
        <Stack align="center">
          <Flex
            bg="var(--mantine-color-neutral-1)"
            h={80}
            w={80}
            align="center"
            justify="center"
            style={{ borderRadius: 'var(--mantine-radius-xs)' }}
          >
            <Image w={60} src={HalftoneTakeout} />
          </Flex>
          <Text variant="body-md" ta="center">
            Please go to your {location.middleware_integrator} settings to view menu syncs, menu
            schedules, and resolve integration errors.
          </Text>
        </Stack>
      </Card>
      <Schedule />
      <ThirdPartyMenus source="Middleware" />
    </Stack>
  );
};
